import { mapPhoneNumber } from 'features/order-tracker/utils';

export class AmendAppointmentSiteContactService {
  static transformResponse(response: api.ContactResponse): common.Contact[] {
    return this.findMainContact(this.mapContacts(response.Contacts), response.CurrentSiteContactIndex);
  }

  static mapContacts(contacts: api.ContactModel[]): common.Contact[] {
    return contacts
      .map(({ ContactKey, Title, FirstName, LastName, HomePhone, WorkPhone, Mobile, Email }) => ({
        contactKey: ContactKey,
        title: Title,
        firstName: FirstName,
        lastName: LastName,
        fullName: `${Title} ${FirstName} ${LastName}`,
        phone: mapPhoneNumber(Mobile || HomePhone || WorkPhone || ''),
        email: Email,
      }));
  }

  static findMainContact(contacts: common.Contact[], index: number): common.Contact[] {
    if (!index) return contacts;

    const mainContact = contacts.splice(index, 1);
    return [...mainContact, ...contacts];
  }
}
